import {
  CreateSenderAccountRequest,
  ISenderAccount,
  UpdateSenderAccountRequest,
} from 'types/senderAccounts/senderAccount.types';

export const CREATE_SENDER_ACCOUNT_REQUEST = 'CREATE_SENDER_ACCOUNT_REQUEST';
export const CREATE_SENDER_ACCOUNT_SUCCESS = 'CREATE_SENDER_ACCOUNT_SUCCESS';
export const CREATE_SENDER_ACCOUNT_FAILURE = 'CREATE_SENDER_ACCOUNT_FAILURE';

export const GET_SENDER_ACCOUNT_BY_ID_REQUEST =
  'GET_SENDER_ACCOUNT_BY_ID_REQUEST';
export const GET_SENDER_ACCOUNT_BY_ID_SUCCESS =
  'GET_SENDER_ACCOUNT_BY_ID_SUCCESS';
export const GET_SENDER_ACCOUNT_BY_ID_FAILURE =
  'GET_SENDER_ACCOUNT_BY_ID_FAILURE';

export const DELETE_SENDER_ACCOUNT_REQUEST = 'DELETE_SENDER_ACCOUNT_REQUEST';
export const DELETE_SENDER_ACCOUNT_SUCCESS = 'DELETE_SENDER_ACCOUNT_SUCCESS';
export const DELETE_SENDER_ACCOUNT_FAILURE = 'DELETE_SENDER_ACCOUNT_FAILURE';

export const CLEAR_SENDER_ACCOUNT_STATE = 'CLEAR_SENDER_ACCOUNT_STATE';

export const UPDATE_SENDER_ACCOUNT_REQUEST = 'UPDATE_SENDER_ACCOUNT_REQUEST';
export const UPDATE_SENDER_ACCOUNT_SUCCESS = 'UPDATE_SENDER_ACCOUNT_SUCCESS';
export const UPDATE_SENDER_ACCOUNT_FAILURE = 'UPDATE_SENDER_ACCOUNT_FAILURE';

export const GET_VERIFIED_SENDER_ACCOUNTS_REQUEST =
  'GET_VERIFIED_SENDER_ACCOUNTS_REQUEST';
export const GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS =
  'GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS';
export const GET_VERIFIED_SENDER_ACCOUNTS_FAILURE =
  'GET_VERIFIED_SENDER_ACCOUNTS_FAILURE';

export interface CreateSenderAccountRequestAction {
  type: typeof CREATE_SENDER_ACCOUNT_REQUEST;
  payload: CreateSenderAccountRequest;
}

export interface CreateSenderAccountSuccessAction {
  type: typeof CREATE_SENDER_ACCOUNT_SUCCESS;
  payload: ISenderAccount;
}

export interface CreateSenderAccountFailureAction {
  type: typeof CREATE_SENDER_ACCOUNT_FAILURE;
  payload: string;
}

export interface GetSenderAccountByIdRequestAction {
  type: typeof GET_SENDER_ACCOUNT_BY_ID_REQUEST;
  payload: {
    id: string;
  };
}

export interface GetSenderAccountByIdSuccessAction {
  type: typeof GET_SENDER_ACCOUNT_BY_ID_SUCCESS;
  payload: ISenderAccount;
}

export interface GetSenderAccountByIdFailureAction {
  type: typeof GET_SENDER_ACCOUNT_BY_ID_FAILURE;
  payload: string;
}

export interface DeleteSenderAccountRequestAction {
  type: typeof DELETE_SENDER_ACCOUNT_REQUEST;
  payload: {
    id: string;
  };
}

export interface DeleteSenderAccountSuccessAction {
  type: typeof DELETE_SENDER_ACCOUNT_SUCCESS;
  payload: string;
}

export interface DeleteSenderAccountFailureAction {
  type: typeof DELETE_SENDER_ACCOUNT_FAILURE;
  payload: string;
}

export interface ClearSenderAccountStateAction {
  type: typeof CLEAR_SENDER_ACCOUNT_STATE;
  [key: string]: any;
}

export interface GetVerifiedSenderAccountsRequestAction {
  type: typeof GET_VERIFIED_SENDER_ACCOUNTS_REQUEST;
  [key: string]: any;
}

export interface GetVerifiedSenderAccountsSuccessAction {
  type: typeof GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS;
  payload: ISenderAccount[];
}

export interface GetVerifiedSenderAccountsFailureAction {
  type: typeof GET_VERIFIED_SENDER_ACCOUNTS_FAILURE;
  payload: string;
}

export interface UpdateSenderAccountRequestAction {
  type: typeof UPDATE_SENDER_ACCOUNT_REQUEST;
  payload: UpdateSenderAccountRequest;
}

export interface UpdateSenderAccountSuccessAction {
  type: typeof UPDATE_SENDER_ACCOUNT_SUCCESS;
  payload: ISenderAccount;
}

export interface UpdateSenderAccountFailureAction {
  type: typeof UPDATE_SENDER_ACCOUNT_FAILURE;
  payload: string;
}

export type SenderAccountActionTypes =
  | CreateSenderAccountRequestAction
  | CreateSenderAccountSuccessAction
  | CreateSenderAccountFailureAction
  | GetSenderAccountByIdRequestAction
  | GetSenderAccountByIdSuccessAction
  | GetSenderAccountByIdFailureAction
  | DeleteSenderAccountRequestAction
  | DeleteSenderAccountSuccessAction
  | DeleteSenderAccountFailureAction
  | ClearSenderAccountStateAction
  | GetVerifiedSenderAccountsRequestAction
  | GetVerifiedSenderAccountsSuccessAction
  | GetVerifiedSenderAccountsFailureAction
  | UpdateSenderAccountRequestAction
  | UpdateSenderAccountSuccessAction
  | UpdateSenderAccountFailureAction;
